import { resolve, BindingMode, ILogger, bindable } from 'aurelia';
import { watch } from '@aurelia/runtime-html';

export class DataPager {

    @bindable pageSize = 100;
    @bindable itemCount;
    @bindable({ mode: BindingMode.twoWay }) pageNumber = 1;

    log = resolve(ILogger).scopeTo('app.Lastminutetrips');

    constructor() { }

    attached() {
        this.setupPagination();
    }

    @watch('itemCount')
    onPaginationChange() {
        this.setupPagination();
    }

    setupPagination() {
        if (this.itemCount === 0) return;
        let skipInitCallback = true;
        $('#pagination-container').pagination({
            dataSource: (done) => {
                let result = [];
                for (let i = 1; i <= this.itemCount; i++) {
                    result.push(i);
                }
                done(result);
            },
            pageSize: this.pageSize,
            callback: (data, pagination) => {
                if (skipInitCallback) return;
                this.pageNumber = pagination.pageNumber;
            }
        });
        skipInitCallback = false;
    }
}
